import { MEDIA_QUERY_STATES } from '@constants/media-query';
import { useLiteStorefront } from '@hooks/use-lite-storefront';
import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useMedia } from '@tkww/orion-web-app-kernel';
import { Decorated } from '@typings/vendor';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-scroll';
import AnalyticsConstants from '../../../../../../../constants/analytics';
import VendorAnalytics from '../../../../../../decorators/vendorAnalytics';
import Styles from './styles.scss';

export interface OwnProps {
	shouldHide?: boolean;
	title: string;
}

interface StateProps {
	vendor: Decorated | null;
}

type Props = OwnProps & StateProps;

const NavItem: React.FC<Props> = ({ shouldHide = false, title, vendor }) => {
	const { track } = useAnalyticsContext();
	const isSmallDesktop =
		useMedia('(max-width: 1279px)') === MEDIA_QUERY_STATES.matched;
	const isLiteStorefront = useLiteStorefront();
	const id = `nav${title}`;

	const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
		event.currentTarget.blur();

		const vendorAnalytics = new VendorAnalytics(vendor || undefined);

		track({
			event: AnalyticsConstants.MINI_NAV_INTERACTION,
			properties: {
				selection: title,
				...vendorAnalytics.baseEventProps(),
			},
		});
	};

	useEffect(() => {
		const observer = new MutationObserver(() => {
			const activeEl = document.querySelector(
				`.${Styles.activeNavLink}`,
			) as HTMLElement;
			if (activeEl) {
				activeEl.scrollIntoView({
					behavior: 'smooth',
					inline: 'center',
					block: 'nearest',
				});
			}
		});

		const container = document.getElementById('nav-bar');
		if (container) {
			observer.observe(container, {
				subtree: true,
				attributes: true,
				attributeFilter: ['class'],
			});
		}

		return () => observer.disconnect();
	}, []);

	const offset = !isLiteStorefront ? (isSmallDesktop ? -140 : -85) : -69;

	return shouldHide ? null : (
		<li className={Styles.navItem} key={id}>
			<Link
				className={Styles.navLink}
				activeClass={Styles.activeNavLink}
				href={`#${id}`}
				to={id}
				smooth
				spy
				isDynamic
				rel={title}
				// The DefinitelyTyped definition for react-scroll is incorrect and doesn't take an event argument.
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				onClick={onClickHandler}
				offset={offset}
			>
				{title}
			</Link>
		</li>
	);
};

function mapStateToProps(state: Redux.State): StateProps {
	return {
		vendor: state.vendor.vendor,
	};
}

export default connect<StateProps, {}, OwnProps>(mapStateToProps)(NavItem);
